<!-- COM Tabla Resumen Balance otros productos  ************************************************************************-->

<div class="balance__resumen">
    <div>
        <table class="table table-striped  tablaResumen">
            <thead class="tablaDetalle__head">
                <tr>
                    <th class="balance__centerTd">Producto</th>
                    <th scope="col">Proveedor</th>
                    <th scope="col">Plataforma</th>
                    <th scope="col">Total Empresas</th>
                </tr>
            </thead>
            <tbody class="tableDetalle__body">
                <tr>
                    <td class="balance__centerTd">{{displayedProducts[0]}}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.proveedorRecargas === null ? '$0' : modalBalanceOtrosProductosDto.proveedorRecargas | currency }}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.gedomRecargas === null ? '$0' : modalBalanceOtrosProductosDto.gedomRecargas | currency}}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.totalEmpresasRecargas === null ? '$0' : modalBalanceOtrosProductosDto.totalEmpresasRecargas | currency}}</td>
                </tr>
                <tr>
                    <td class="balance__centerTd">{{displayedProducts[1]}}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.proveedorFacturas === null ? '$0' : modalBalanceOtrosProductosDto.proveedorFacturas | currency}}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.gedomFacturas === null ? '$0' : modalBalanceOtrosProductosDto.gedomFacturas | currency}}</td>
                    <td class="balance__centerTd">{{modalBalanceOtrosProductosDto.totalEmpresasFacturas === null ? '$0' : modalBalanceOtrosProductosDto.totalEmpresasFacturas | currency}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>